// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4528) return "static/chunks/4528-232f84b09ad909df.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3617":"a7cd1141","8662":"e4fac512"}[chunkId] || chunkId) + "." + {"3184":"f2fddf48f0433bdd","3617":"93585d36efacdce7","4342":"cdad62a380ce8fac","5283":"37cfca524d89547f","7012":"c632829e98eee81b","7874":"f27cd0b6f6e0b038","8233":"324ed783dd4c640a","8269":"9edfb4bab747ef94","8662":"e0e14ab13bb9127b"}[chunkId] + ".js";
};